<template>
    <a-card>
        <a-form class="table-search" ref="searchForm" layout="inline" :model="searchForm">、
            <a-form-item label="产品名称" name="productName">
                <a-input v-model:value="searchForm.productName" placeholder="请输入产品名称" />
            </a-form-item>
            <a-form-item>
                <a-button type="primary" @click="onSearch">查询</a-button>
                <a-button @click="onReset">重置</a-button>
            </a-form-item>
        </a-form>
        <div class="table-toolbar">
            <!-- <a-button type="primary" @click="onAdd">
                <template #icon>
                    <plus-outlined/>
                </template>
                新增
            </a-button> -->
            <!-- <a-popconfirm title="确认要删除吗?" @confirm="onDeleteBatch(deleteUrl)" v-if="selectedRowKeys.length">
                <a-button danger>批量删除</a-button>
            </a-popconfirm> -->
        </div>
        <a-alert type="info" showIcon class="table-alert" v-if="selectedRowKeys.length">
            <template #message>
                已选择 {{ selectedRowKeys.length }} 项
                <a @click="onClearSelected" class="ml-20 float-right">清空</a>
            </template>
        </a-alert>
        <a-table
            :columns="columns"
            :pagination="pagination"
            :data-source="dataSource"
            :loading="loading"

            @change="onTableChange">

            <template #img="{record}">
                <div v-if="record.img" style="position: relative; width:35px; height:35px; margin: 3px 3px; overflow: hidden;">
                <img-upload style="position: absolute; top:-35px; left:-35px" v-model:value="record.img" :showList="true" disabled />
                </div>
                <div v-else style="position: relative; width:35px; height:35px; margin: 3px 3px; overflow: hidden;">
                    <img src="@/assets/img/defaultPhoto.png" style="width:100%" alt="">
                </div>
            </template>
            <template #type="{ text }">
                <dict-render :dict-obj="dictObjs['loanType']" :text="text"></dict-render>
            </template>
            <template #auditStatus="{ text }">
                <dict-render :dict-obj="dictObjs['aduit_status']" :text="text"></dict-render>
            </template>
            <template #loanTime="{ record }">
                {{ momentFormat(record.loanTime,'YYYY-MM-DD') }}
            </template>
            <template #creditTime="{ record }">
                {{ momentFormat(record.creditTime,'YYYY-MM-DD') }}
            </template>
            <template #action="{record}">
                <div class="table-row-operations">
                    <!--                    <a @click="onStateus(record)">服务状态修改</a>-->
                    <a v-if="record.auditStatus==2" @click="onEdit(record)">编辑</a>
                    <a v-else @click="onDetail(record)">查看</a>
                </div>
            </template>
        </a-table>
    </a-card>
    <AddOrEditModal ref="modal" :form-primary-key-field="listKeyField" @finish="onFormEdited"/>
    <Detail ref="detailmodal" :form-primary-key-field="listKeyField" @finish="onFormEdited" @onCloseModel="onCloseModel"/>
</template>

<script>
import AddOrEditModal from "./components/AddOrEditModal";
import {tableListMixin, dictMixin} from "@/mixins";
import {financeLoan} from "@/api/finance";
import {financeDict} from "@/config/variableConfig";
import DictRender from "@/components/other/DictRender";
import Detail from "./components/Detail";

const columns = [
    // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
    // {title: "主图", dataIndex: "img", key: "img", slots: {customRender: "img"}},
    {title: "产品名称", dataIndex: "productName", key: "productName", slots: {customRender: "productName"}},
    {title: "联系人", dataIndex: "contact", key: "contact"},
    {title: "联系电话", dataIndex: "contactNumber", key: "contactNumber"},
    {title: "申请贷款额度(万元)", dataIndex: "loanAmount", key: "loanAmount"},
    // {title: "类型", dataIndex: "type", key: "type", slots: {customRender: "type"}},
    // {title: "审核状态", dataIndex: "auditStatus", key: "auditStatus", slots: {customRender: "auditStatus"}},
    // {title: "授信金额", dataIndex: "creditAmount", key: "creditAmount"},
    // {title: "贷款时间", dataIndex: "loanTime", key: "loanTime", slots: {customRender: "loanTime"}},
    // {title: "授信时间", dataIndex: "creditTime", key: "creditTime", slots: {customRender: "creditTime"}},
    // {title: "审核人", dataIndex: "auditor", key: "auditor"},
    {title: "操作",  dataIndex: "action", key: "action", slots: {customRender: "action"}},
];
export default {
    name: "金融产品申请",
    mixins: [tableListMixin,dictMixin],
    components: {
        AddOrEditModal,
        DictRender,
        Detail,
    },
    data() {
        return {
            financeDict,
            dictNames: 'loanType,aduit_status',
            columns,
            queryParam: {},
            listUrl: financeLoan.pageList,
            listKeyField: "id",
            deleteUrl: financeLoan.remove
        }
    },
    methods: {
        onAdd() {
            this.onShowModal('modal');
        },
        onEdit(record) {
            this.getAction({
                url: financeLoan.detail,
                params: {id: record.id}
            }).then(res => {
                this.onShowModal('modal', res);
            })
        },

        onDetail(record){
            this.getAction({
                url: financeLoan.detail,
                params: {id: record.id}
            }).then(res=>{
                this.onShowModal("detailmodal", res)
            })
        }
    }
}
</script>

<style scoped>

</style>
